import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["icon"]
  static values = { 
    postId: Number,
    bookmarked: Boolean
  }

  connect() {
    console.log('🔖 Bookmark Controller connected for post', this.postIdValue)
  }

  async toggle() {
    console.log('🔄 Toggling bookmark for post', this.postIdValue)
    
    try {
      // Optimistically update the UI
      const wasBookmarked = this.bookmarkedValue
      this.setBookmarkState(!wasBookmarked)
      
      // Make the API request
      const response = await fetch(`/posts/${this.postIdValue}/bookmark`, {
        method: wasBookmarked ? 'DELETE' : 'POST',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'X-CSRF-Token': this.getCSRFToken()
        }
      })
      
      if (response.ok) {
        const data = await response.json()
        console.log('✅ Bookmark toggled successfully:', data.bookmarked ? 'bookmarked' : 'removed')
        
        // Update state from server response
        this.bookmarkedValue = data.bookmarked
        this.setBookmarkState(data.bookmarked)
        
        // Show feedback
        this.showFeedback(data.bookmarked ? 'Bookmarked!' : 'Bookmark removed')
      } else {
        throw new Error('Failed to toggle bookmark')
      }
    } catch (error) {
      console.error('❌ Error toggling bookmark:', error)
      
      // Revert optimistic update
      this.setBookmarkState(this.bookmarkedValue)
      this.showFeedback('Failed to toggle bookmark', 'error')
    }
  }

  setBookmarkState(bookmarked) {
    if (this.hasIconTarget) {
      if (bookmarked) {
        this.iconTarget.className = 'fas fa-bookmark'
        this.element.classList.add('text-yellow-500')
      } else {
        this.iconTarget.className = 'far fa-bookmark'
        this.element.classList.remove('text-yellow-500')
      }
    }
  }

  showFeedback(message, type = 'success') {
    // Create temporary feedback element
    const feedback = document.createElement('div')
    feedback.className = `fixed top-4 right-4 z-50 px-3 py-2 rounded-lg text-xs font-medium transition-all duration-300 ${
      type === 'success' 
        ? 'bg-green-100 text-green-800 border border-green-200' 
        : 'bg-red-100 text-red-800 border border-red-200'
    }`
    feedback.textContent = message
    feedback.style.opacity = '0'
    feedback.style.transform = 'translateY(-10px)'
    
    document.body.appendChild(feedback)
    
    // Animate in
    requestAnimationFrame(() => {
      feedback.style.opacity = '1'
      feedback.style.transform = 'translateY(0)'
    })
    
    // Remove after delay
    setTimeout(() => {
      feedback.style.opacity = '0'
      feedback.style.transform = 'translateY(-10px)'
      setTimeout(() => {
        if (document.body.contains(feedback)) {
          document.body.removeChild(feedback)
        }
      }, 300)
    }, 2000)
  }

  getCSRFToken() {
    const token = document.querySelector('meta[name="csrf-token"]')
    return token ? token.getAttribute('content') : null
  }
}